<template>
<div class="events">
  DONATION GOALS
  <div>
    <li v-for="goals in overlayData">
      {{goals.name}}: ${{goals.amount}}
    </li>
  </div>
</div>
</template>

<script>
  import axios from 'axios'

  export default {
    mounted() {
      this.loadData()
    },
    data () {
      return {
        overlayData: []
      }
    },
    methods: {
      loadData () {
        axios.get(`/api/overlay/display`).then(({ data }) => {
          this.overlayData = data.overlay.goals
          console.log("touch butts")
        })
      }
    }
  }
</script>

<style scoped>
.events {
  position:fixed;
  background-color:green;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight:600;
  font-size:3vh;
  color:white;
  height:37vh;
  width:35vw;
  top:60vh;
  left:35vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Events.vue